import { Context, useCallback, useContext, useMemo } from 'react'
import {
  ApiClientContext,
  EventBusContext,
  HorizonContext,
  HostContext,
  RegistryContext,
} from '../context'
import { EventBus } from '../events'
import { validateAndMergeContext } from '../utils'

export const useEventBusContext = <EventType>() =>
  useContext(EventBusContext as Context<EventBus<EventType>>)

export const useApiClientContext = () => useContext(ApiClientContext)

export const useHostContext = () => useContext(HostContext)

export const useRegistryContext = () => useContext(RegistryContext)

export const useHorizonContext = () => {
  const host = useHostContext()
  const eventBus = useEventBusContext()
  const apiClient = useApiClientContext()
  const registry = useRegistryContext()

  const context = useMemo<HorizonContext>(
    () => ({
      host,
      eventBus,
      apiClient,
      registry,
    }),
    [host, eventBus, apiClient, registry],
  )

  const validateAndMerge = useCallback(
    (newContext: Partial<HorizonContext> = {}) =>
      validateAndMergeContext(context, newContext),
    [context],
  )

  return {
    ...context,
    validateAndMerge,
  }
}
